import Monitoring from './Monitoring';

export default Monitoring;
